import { Flex, Image } from "@chakra-ui/react";
import React from "react";

export const BlankChat = () => {
  return (
    <Flex
      w="100%"
      h="80%"
      overflow="hidden"
      flexDirection="column"
      align="center"
      justify="center"
      mt={{ base: 2, md: 50 }}
    >
      <Image
        src="https://assets.hardwarezone.com/img/2023/05/Google_Chat_icon__2020_.jpg"
        alt="image"
        w={{ base: "80%", md: "60%" }}
        h="auto"
        objectFit="cover"
      />
    </Flex>
  );
};
